export enum FORM_VALIDATION_RULE_TYPE {
    internal = 'internal',
    required = 'required',
    regexp = 'regexp',
    email = 'email',
    amount = 'amount',
    number = 'number',
    length = 'length',
    range = 'range',
    dateRange = 'dateRange',
    exclusion = 'exclusion',
    // extended types
    confirm = 'confirm',
    fn = 'fn',
    unlimited = 'unlimited' // TotalCasino changes
}

export enum FORM_RULE_CONDITION_OPERATOR {
    equal = 'ComparisonOperator.Equal',
    notEqual = 'ComparisonOperator.NotEqual'
}

export enum FORM_FIELD_TYPE {
    TEXT_LABEL = 'textLabel',
    BUTTON = 'button',
    SEPARATOR = 'separator',
    TEXT = 'text',
    CHECKBOX = 'checkbox',
    DROPDOWN = 'dropdown',
    RADIO_BUTTON = 'radioButton',
    DATE_PICKER = 'datePicker',
    ADDRESS_LOOKUP_SWISS = 'addressLookupSwiss',
    ADDRESS_LOOKUP = 'addressLookup',
    PLACE_OF_BIRTH = 'placeOfBirth',
    PLACE_OF_RESIDENCE = 'placeOfResidence',
    USER_NAME = 'userName',
    PASSWORD = 'password',
    CONTACT_PREFERENCES = 'contactPreferences',
    COUNTRY = 'country',
    CURRENCY_CODE = 'currencyCode',
    CELLPHONE = 'cellphone',
    PHONE = 'phone',
    DEPOSIT_LIMITS = 'depositLimits',
    BET_LIMITS = 'betLimits',
    LOSS_LIMITS = 'lossLimits',
    DATE_OF_BIRTH = 'dateOfBirth',
    EMAIL = 'email',
    POLAND_ID = 'polandID',
    ROMANIAN_ID = 'romanianID',
    SPANISH_ID = 'spanishID',
    PORTUGAL_ID = 'portugalID',
    SOUTH_AFRICAN_ID = 'southAfricanID',
    ITALIAN_ID = 'italianID',
    IBAN = 'iban',
    // address lookup inner fields
    ZIP = 'zip',
    CITY = 'city',
    STREET_NAME = 'streetName',
    HOUSE_NUMBER = 'houseNumber',
    PROPERTY_NUMBER = 'propertyNumber',
    PROVINCE = 'province',
    SUBBUILDING = 'subbuilding',
    UNIT_NUMBER = 'unitNumber',
    STATE = 'state',
    ADDRESS = 'address',
    ADDRESS_2 = 'address2',
    BUILDING_NUMBER = 'buildingNumber',
    // place of birth inner fields
    DATE_OF_BIRTH_INNER = 'dateOfBirthInner',
    COUNTRY_OF_BIRTH = 'countryOfBirth',
    BIRTH_PROVINCE = 'birthProvince',
    CITY_OF_BIRTH = 'cityOfBirth',
    // place of residence inner fields
    COUNTRY_OF_RESIDENCE = 'countryOfResidence',
    PROVINCE_OF_RESIDENCE = 'provinceOfResidence',
    CITY_OF_RESIDENCE = 'cityOfResidence'
}

export enum FORM_FIELD_BUTTON_ACTION {
    SUBMIT = 'submit',
    NEXT = 'next'
}

export enum FORM_FIELD_BUTTON_ALIGN {
    CENTER = 'center',
    LEFT = 'left',
    RIGHT = 'right'
}

export enum DATE_FIELD_DISPLAY_TYPE {
    SELECTOR = 'selector',
    INPUT = 'dateInput'
}
